/**
 * @param classNames Class names to be added to the element with boolean values
 * 
 * @example
 * const element = <div className={cx({ className1: true, className2: false })} />
 * @returns {string}
 */
const cx = (classNames: any) => {
    return Object.keys(classNames).filter(key => classNames[key]).join(' ');
}
export default cx;